import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import breakpoints from '../../shared/breakpoints';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  > .nw-content-container {
    width: ${props => props.width};
  }
`;

export default function NavbarWidthContainer({ clsName, children }) {
  const isXXLarge = useMediaQuery({ minWidth: breakpoints.xxlargeMin });
  const isXLarge = useMediaQuery({ minWidth: breakpoints.xlargeMin });
  const isLarge = useMediaQuery({ minWidth: breakpoints.largeMin });

  let width = 'calc(100% - 40px)';
  if (isXXLarge) {
    width = '1200px';
  } else if (isXLarge) {
    width = '953px';
  } else if (isLarge) {
    width = '85%';
  }

  return (
    <Wrapper className={clsName} width={width}>
      <div className="nw-content-container">
        {children}
      </div>
    </Wrapper>
  );
}

NavbarWidthContainer.propTypes = {
  clsName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

NavbarWidthContainer.defaultProps = { clsName: '' };
